import { observable } from "mobx";
import { Type } from "class-transformer";
import ChargeOverlapResponse from "./chargeOverlapResponse";
import ChargeOverlapType from "./chargeOverlapType";
import ProposedChargeValidityResponse from "./proposedChargeValidityResponse";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class ChargeValidityInstructionsResponse {
  /**
   * Calculated valid since based on requested validity.
   */
  @observable
  @Type(() => Date)
  validSince!: Date;

  /**
   * Calculated valid until based on requested validity.
   */
  @observable
  @Type(() => Date)
  validUntil!: Date;

  @observable
  @Type(() => ProposedChargeValidityResponse)
  proposedValidity?: ProposedChargeValidityResponse;

  /**
   * Existing overlapping charges - max 3 most relevant overlaps.
   */
  @observable
  @Type(() => ChargeOverlapResponse)
  overlappingCharges?: ChargeOverlapResponse[];

  /**
   * Charge overlaps.
   */
  @observable
  overlapTypes?: ChargeOverlapType[];
}
